import { useEffect, useState } from 'react'
import { globalWebSocket } from './globalWebSocket'
import { useAuthStore } from '../auth/store'

/**
 * Простой хук для использования глобального WebSocket
 * НЕ создает новых подключений, только слушает состояние
 */
export function useGlobalWebSocket() {
  const [isConnected, setIsConnected] = useState(false)
  const [connectionStatus, setConnectionStatus] = useState<string>('disconnected')
  const webSocketUserId = useAuthStore((s) => s.webSocketUserId)
  const token = useAuthStore((s) => s.token)
  const mode = useAuthStore((s) => s.mode)

  useEffect(() => {


    // Обработчики событий
    const handleConnectionEstablished = () => {
      setIsConnected(true)
      setConnectionStatus('connected')
    }
    
    const handleClose = () => {
      setIsConnected(false)
      setConnectionStatus('disconnected')
    }
    
    const handleError = () => {
      setIsConnected(false)
      setConnectionStatus('error')
    }

    // Подписываемся на события
    globalWebSocket.on('connection_established', handleConnectionEstablished)
    globalWebSocket.on('close', handleClose)
    globalWebSocket.on('error', handleError)

    // Устанавливаем начальное состояние
    if (!webSocketUserId || !token) {
      setConnectionStatus('no_auth')
      setIsConnected(false)
    } else {
      setConnectionStatus('connecting')
    }

    // Очистка при размонтировании
    return () => {
      globalWebSocket.off('connection_established', handleConnectionEstablished)
      globalWebSocket.off('close', handleClose)
      globalWebSocket.off('error', handleError)
    }
  }, [webSocketUserId, token, mode])

  return { 
    isConnected, 
    connectionStatus, 
    service: globalWebSocket.getService(),
    // Дополнительная информация для отладки
    debugInfo: {
      webSocketUserId,
      mode,
      hasToken: !!token
    }
  }
}
